import React, { Component } from "react";
import App from "./App";
import { generateCipher, applyCipher } from "../utils/cipher";
import { alphabet } from "../utils/constants";
import {
  getUnsolvedQuote,
  getSolvedQuotes,
  markQuoteAsSolved,
} from "../quotesRepo";
import type { Quote } from "./types";

const MOBILE_SIZE = 1024;

const getCharacters = (
  cipher: { [letter: string]: string },
  currentQuote: Quote | undefined
) => {
  if (!currentQuote) {
    return [];
  }

  let id = 0;

  return applyCipher(currentQuote.text, cipher)
    .split("")
    .map((letter) => ({
      id: alphabet.includes(letter) ? ++id : null,
      letter,
    }));
};

type AppContainerProps = {};

type AppContainerState = {
  cipher: { [letter: string]: string };
  currentQuote: Quote | undefined;
  isMobile: boolean;
  solvedQuotes: Quote[];
  isRTL: boolean; // Added state for RTL mode
};

class AppContainer extends Component<AppContainerProps, AppContainerState> {
  state: AppContainerState = {
    cipher: generateCipher(),
    currentQuote: getUnsolvedQuote(),
    isMobile: window.innerWidth < MOBILE_SIZE,
    solvedQuotes: getSolvedQuotes(),
    isRTL: true, // Set to true for RTL mode, false for LTR mode
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < MOBILE_SIZE });
  };

  handleGetNewQuote = () => {
    this.setState({
      cipher: generateCipher(),
      currentQuote: getUnsolvedQuote(),
    });
  };

  handleMarkAsSolved = () => {
    if (this.state.currentQuote) {
      markQuoteAsSolved(this.state.currentQuote);
      this.setState({ solvedQuotes: getSolvedQuotes() });
    }
  };

  toggleRTL = () => {
    this.setState((prevState) => ({ isRTL: !prevState.isRTL }));
  };

  render() {
    const { cipher, currentQuote, solvedQuotes, isMobile, isRTL } = this.state;

    return (
      <div >
        <App
          cipher={cipher}
          characters={getCharacters(cipher, currentQuote)}
          currentQuote={currentQuote || { id: "", name: "", text: "", context: null, occupation: null, time: null }}
          solvedQuotes={solvedQuotes}
          onGetNewQuote={this.handleGetNewQuote}
          onMarkAsSolved={this.handleMarkAsSolved}
          isMobile={isMobile}
        />
        {/* <button onClick={this.toggleRTL}>Toggle RTL</button> */}
      </div>
    );
  }
}

export default AppContainer;
